import { useEffect, useRef, type JSX } from "react";
import { useStore } from "../store/globalState";
import { CloseLight } from "../assets/navIcons";

export interface PopupProps {
  children: JSX.Element;
  visible?: boolean;
  onClose: () => void;
  showClose?: boolean;
  /** False keeps the popup open on a click outside it. */
  dismissOnOutsideClick?: boolean;
}

export const Popup: React.FC<PopupProps> = ({
  visible,
  onClose,
  children,
  showClose = true,
  dismissOnOutsideClick = true,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const { footerColor } = useStore().theme.whiteView;

  useEffect(() => {
    if (!visible || !dismissOnOutsideClick) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [visible, onClose, dismissOnOutsideClick]);

  if (!visible) return null;

  return (
    <>
      <span className="popup-blur" />
      <main ref={ref} role="alert" className="popup-component">
        {showClose && (
          <CloseLight
            className="close-popup-icon"
            onClick={onClose}
            colors={[footerColor, footerColor]}
          />
        )}
        {children}
      </main>
    </>
  );
};
